import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type AdjuntoElements = {
  adjunto: SxProps
  icon: SxProps
  nombre: SxProps
}

export const adjuntoStyles: AdjuntoElements = {
  adjunto: {
    alignItems: 'center',
    color: theme.palette.primary.main,
    display: 'flex',
    marginRight: theme.spacing(2),
    maxWidth: 300,
    padding: theme.spacing(1, 0)
  },

  icon: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginRight: theme.spacing(1)
  },

  nombre: {
    fontSize: 14,
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}
